import React from 'react';

/**
 * Checks if a specific React component type exists anywhere in the node tree.
 * @param rootNode The root React node to search.
 * @param childType The React component type to look for.
 * @returns boolean indicating if the childType exists in the tree.
 */
export function useHasSpecificChild(
  rootNode: React.ReactNode,
  childType: React.ElementType
): boolean {
  const containsChild = React.useCallback(
    (node: React.ReactNode): boolean => {
      if (!node) return false;
      if (Array.isArray(node)) return node.some(containsChild);
      if (React.isValidElement(node)) {
        if (node.type === childType) return true;
        return containsChild(node.props.children);
      }
      return false;
    },
    [childType]
  );

  return containsChild(rootNode);
}
